export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map_36.de81dbed.jpg";